/**
 * Stable CSS class names for E2E — Schedule detail card.
 */
export const SDC = {
    card: 'schedule-detail-card',
    content: 'schedule-detail-card__content',
} as const;

export const sdcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

